import { DateTime } from 'luxon';

export const LAST_REFRESH_STORAGE_KEY = 'lastTimeWeRefreshedBecauseOfNewDeploy';
const MINIMUM_MINUTES_BETWEEN_REFRESHES = 10;

const hasBeenMoreThanTenMinutesSinceLastRefreshBecauseOfNewDeploy = (): boolean => {
	const previousTimeString = window.sessionStorage.getItem(LAST_REFRESH_STORAGE_KEY);
	if (previousTimeString) {
		const previousTime = DateTime.fromISO(previousTimeString);
		return DateTime.now().diff(previousTime, 'minutes').minutes > MINIMUM_MINUTES_BETWEEN_REFRESHES;
	}
	return true;
};

const recordRefreshIfDue = (): boolean => {
	try {
		if (!hasBeenMoreThanTenMinutesSinceLastRefreshBecauseOfNewDeploy()) {
			return false;
		}
		window.sessionStorage.setItem(LAST_REFRESH_STORAGE_KEY, DateTime.now().toUTC().toISO());
		return true;
	} catch {
		return false;
	}
};

export const reloadWhenPreloadFailsBecauseOfNewDeploy = (event: Event): void => {
	event.preventDefault();
	if (recordRefreshIfDue()) {
		window.location.reload();
	}
};
